'use strict';

var d3 = require('d3');
var Chart = function Chart(AbstractChart, chartGroups, chartBars, chartXAxis, chartYAxis, chartConstants, chartYAxisLines) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('bardragged');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var groups = chartGroups('value', undefined, false).withHooverTracking();
    var draggableBars = chartBars('share').maxItemsCount(2);
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withoutLine();
    var yAxis = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.RIGHT).withoutHorizontalLines();
    var lines = chartYAxisLines();
    this.render = function (data, wideLabelsMode) {
      this.initChart(data, [0, data.length], chartParams(data.length, wideLabelsMode));
      this.scales = chartScales(this.params, this.data, wideLabelsMode);
      this.callForDataGroup([lines, groups, draggableBars, xAxis], this.scales);
      this.callForYAxis(yAxis, this.scales);
    };
    draggableBars.on('bardragged', function (d) {
      dispatch.bardragged(d.value, d.share);
    });
    this.withDraggable = function (isDraggable) {
      draggableBars.draggable(isDraggable);
      return this;
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
Chart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsDraggableBars', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants', 'ChartElementsYAxisLines'];
module.exports = Chart;